// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"845abf9f","213":"448ae3c2","239":"e39fb35b","455":"d639c004","762":"81502f2c","809":"84b26fd6"}[chunkId] + ".chunk.js";
};